import { useMutation, useQueryClient } from 'react-query';

import { createAppPoison as create } from 'api/visitReports/createAppPoison';

const useAddPoison = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: createAppPoison,
    isLoading,
  } = useMutation(create, {
    onSuccess: () => {
      queryClient.invalidateQueries('visitDocs');
    },
  });

  return {
    isSuccess,
    createAppPoison,
    isLoading,
  };
};

export default useAddPoison;
